import React, { useState } from "react";
import { CustomSnackbar } from "../../../helpers/CustomSnackbar";
import VerifyEmail from "./VerifyEmail";
import VerifyMobile from "../../../helpers/Common/VerifyMobile";
import PropTypes from "prop-types";
import "./VerifyEmailAndMobile.css";

const VerifyEmailAndMobile = ({ formData }) => {
  const [currentStep, setCurrentStep] = useState("mobile"); // "mobile" or "email"
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);

  const handleMobileVerificationSuccess = () => {
    setMobileVerified(true);
    setCurrentStep("email");
    CustomSnackbar.success(
      "Mobile number verified successfully! Now verify your email.",
    );
  };

  const handleEmailVerificationSuccess = () => {
    setEmailVerified(true);
  };

  const renderStepIndicator = () => (
    <div className="stepper-container">
      <div
        className={`step-indicator ${
          currentStep === "mobile"
            ? "active"
            : mobileVerified
            ? "completed"
            : ""
        }`}
      >
        <div className="step-number">1</div>
        <div className="step-label">Mobile Number Verification</div>
      </div>
      {/* <div className={`step-line ${mobileVerified ? "completed" : ""}`}></div>
      <div className={`step-indicator ${currentStep === "email" ? "active" : emailVerified ? "completed" : ""}`}>
        <div className="step-number">2</div>
        <div className="step-label">Email</div>
      </div> */}
    </div>
  );

  const renderContent = () => {
    switch (currentStep) {
      case "mobile":
        return (
          <VerifyMobile
            formData={formData}
            onVerifyMobileSuccess={handleMobileVerificationSuccess}
          />
        );
      case "email":
        return (
          <VerifyEmail
            formData={formData}
            showLoginBtn={false}
            isMultiStep={true}
            onVerifyEmailSuccess={handleEmailVerificationSuccess}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-100">
      {renderStepIndicator()}
      {renderContent()}
    </div>
  );
};

VerifyEmailAndMobile.propTypes = {
  formData: PropTypes.object,
};

export default VerifyEmailAndMobile;
